import axios from '@/plugins/Axios'
import Mapper from './Mapper'

function Requests () {
  async function quickSearch(params) {
    try {
      const { data } = await axios.get('/quick-search', { params })
      return Mapper.quickSearchResult(data)
    } catch (error) {
      console.log(error)
    }
  }

  async function getProductInfo(id) {
    try {
      const { data } = await axios.get(`/product/${id}`)
      return data.result ? Mapper.product(data) : data
    } catch (error) {
      return error.response.data
    }
  }

  async function getProductPreviewInfo(id) {
    try {
      const { data } = await axios.get(`/product/${id}/preview`)
      return data.result ? Mapper.product(data) : data
    } catch (error) {
      return error.response.data
    }
  }

  async function fetchSearchResults(params = null) {
    try {
      const { data } = await axios.get('/search', {params})
      return Mapper.searchResult(data)
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchFilters(params = null) {
    try {
      const { data } = await axios.get('/search-filter', {params})
      return Mapper.setFilters(data)
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchFeaturedProducts() {
    try {
      const { data } = await axios.get('/featured-products')
      return data.products.map(product=> Mapper.featureProduct(product))
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchHotProducts() {
    try {
      const { data } = await axios.get('/hot-products')
      return Mapper.hotProducts(data)
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchNewProducts() {
    try {
      const { data } = await axios.get('/newest-products')
      return data.products.map(product=> Mapper.featureProduct(product))
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchTrendingProducts() {
    try {
      const { data } = await axios.get('/trending-products')
      return data.products.map(product=> Mapper.featureProduct(product))
    } catch (error) {
      console.log(error)
    }
  }

  return {
    quickSearch,
    getProductInfo,
    getProductPreviewInfo,
    fetchSearchResults,
    fetchFilters,
    fetchFeaturedProducts,
    fetchHotProducts,
    fetchNewProducts,
    fetchTrendingProducts
  }
}

export default Requests()